import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loaderSection">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
